{
    "MainTitleAdd": "Ajouter l'environnement de gestion centrale",
    "MainTitleModify": "Modifier l'environnement de gestion centrale",
    "DomainsTitle": "Profil du domaine",
    "ProvisioningTitle": "Approvisionnement",
    "EstateTitle": "Succession",
    "UnknownDescription": "[Description inconnue]",
    "LanguageCME_ButtonHelpLabel": "De l'aide ?",
    "LanguageCME_ButtonSubmitLabel": "OK",
    "LanguageCME_ButtonCancelLabel": "Annuler",
    "LanguageCME_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
    "LanguageCME_PromptConfirm": "Oui",
    "LanguageCME_PromptCancel": "Annuler",
    "LanguageCME_DetailsTitle": "Détails de la FMC",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Gestion des licences",
    "CME_AdvancedTabTitle": "Avancé",
    "CME_Fields_RecursiveRealTimeBots": "Activer\/désactiver le temps réel pour tous les serveurs Tel",
    "CME_EnableVoiceAppBots": "Démarrer en temps réel pour {} Serveurs Tel",
    "CME_EnableVoiceAppBots_Recursive": "Démarrage en temps réel pour tous les serveurs Tel",
    "CME_DisableVoiceAppBots": "Stop Real-Time pour {} Serveurs Tel",
    "CME_DisableVoiceAppBots_Recursive": "Arrêter le temps réel pour tous les serveurs Tel",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Veuillez noter que le déclenchement de cette option peut entraîner une détérioration des fonctionnalités au sein du locataire. Cette option ne doit être utilisée qu'après avoir consulté notre équipe d'assistance.",
    "CapabilitiesTitle": "Capacités",
    "BrandingTitle": "Image de marque"
}